export enum ShowProject {
  none = "none",
  detail = "detail",
  tasks = "tasks",
  assignments = "assignments",
}
